import React, { Component } from "react";
import SignInAPI from "../api/sign_in";
import { setAuthData } from "../store/auth/actions";
import { connect } from "react-redux";
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
    };
  }
  handleSubmit = () => {
    console.log("Button Is Clicked!");
    console.log(this.state.email);
    console.log(this.state.password);
    // this.props.setAuthData({
    //   currentUser: {
    //     user_id: "1",
    //     email: "sample_email@gmail.com",
    //   },
    // });

    SignInAPI.verify({
      session: {
        email: this.state.email,
        password: this.state.password,
      },
    })
      .then((response) => {
        console.log("SigninAPI Response:", response.data);
        this.props.setAuthData({
          currentUser: {
            user_id: response.data.user_id,
            email: response.data.email,
          },
          token: response.headers.authorization,
        });
         //set JWT token to local
         localStorage.setItem("token", response.headers.authorization)
      })
      .catch((error) => {
        console.log("SigninAPI Error:", error);
      });
  };
  render() {
    return (
      <div className="signinMain">

        <div className="emailFieldContainer fieldsContainer">
          <div className="emailLabelContainer labelsContainer">
            <label>EMAIL:</label>
          </div>
          <input
            className="email_input inputClasses"
            type="email"
            value={this.state.email}
            onChange={(e) => {
              this.setState({
                email: e.target.value,
              });
            }}
          />
        </div>

        <div className="passFieldContainer fieldsContainer">
          <div className="passLabelContainer labelsContainer">
            <label>PASSWORD:</label>
          </div>
          <input
            className="password_input inputClasses"
            type="password"
            value={this.state.password}
            onChange={(e) => {
              this.setState({
                password: e.target.value,
              });
            }}
          />
        </div>

        <button className="signinButton" type="submit" onClick={this.handleSubmit}>
          Sign In
        </button>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setAuthData: (data) => dispatch(setAuthData(data)),
  };
};
export default connect(null, mapDispatchToProps)(SignIn);
